import React from 'react';

//import { ListToggle } from "../list-toggle";

import { GridToggle } from './../grid-toggle/index';

import GridIconSvg from '../../../svgs/GridIconSvg';
import ListIconSvg from '../../../svgs/ListToggleIconSvg';
import styles from './index.module.scss';

type ProductNavProps = {
	toggle: boolean;
	setToggle: (v: boolean) => void;
	children: React.ReactNode;
};

const ProductNav = ({ toggle, setToggle, children }: ProductNavProps) => {
	return (
		<section className={`flex items-center justify-between gap-4 md:gap-8 mt-[50px] md:mt-0 ${styles.wrapper}`}>
			{children}
			<div>
				{toggle ? (
					<GridToggle onClick={() => setToggle(!toggle)}>
						<ListIconSvg />
					</GridToggle>
				) : (
					<GridToggle onClick={() => setToggle(!toggle)}>
						<GridIconSvg />
					</GridToggle>
				)}
			</div>
		</section>
	);
};

export default React.memo(ProductNav);
